import { TTasaExViewModel } from '../../../core/_infrastructure/types/common';
import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';

export class SolicitudTasasExViewModel {
    constructor() {}

    public Id: number;
    public IdEstadoSolicitudEx = 0;
    public FechaCreacion: Date;
    public IdEstadoSolicitudExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TTasaExCollection: TTasaExViewModel[];
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}
